import React, { useState, useEffect } from 'react';
import {Alert, Table, Spinner, Button, Modal, Card, Row, Col} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { getFuncFichaEmpleado } from '../../redux/func_ficha_empleados/actions';
import { getVaccinesEmp } from '../../redux/vaccinesEmployees/actions'
import CustomNavbar from '../../components/CustomNavbar';
import SidebarDashboard from '../../components/SidebarDashboard';
import UserHeadDetail from '../../components/UserHeadDetail';
import UserHeadDetailMenu from '../../components/UserHeadDetailMenu';
import accesoDenegado from '../../images/acceso-denegado.png';
const Health = props => {

  //States
  const [showModal, setShowModal] = useState(false);
  //const handleClose = () => setShow(false);
  //const handleShow = () => setShow(true);

  const dispatch = useDispatch();
  const data = useSelector(store => store.funcTabEmployeed.ficha_empleado);
  const loading = useSelector(store => store.funcTabEmployeed.loadingFicha_Empleado);

  //vacunas empleados
  const vaccines = useSelector(store => store.vaccinesEmp.vacsEmp);
  const vaccinesLoading = useSelector(store => store.vaccinesEmp.loading);

  //Auth
  const idUser = useSelector(store => store.auth.id);
  const userRoles = useSelector(store => store.auth.userRoles);

  useEffect(() => {
    if (parseInt(props.match.params.id) !== parseInt(idUser) && userRoles.includes('jefe')){
      setShowModal(true);
    }else{
      dispatch(getFuncFichaEmpleado(props.match.params.id, parseInt(props.match.params.type)));
      dispatch(getVaccinesEmp({
        filter: props.match.params.id,
        itype: parseInt(props.match.params.type),
        empleado: props.match.params.id}));
    }
  }, [dispatch, props.match.params.id, props.match.params.type, idUser, userRoles])

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);

//para el calculo de edad

  return(
    <div style={showModal ? {filter: 'blur(6px)'} : null}>
      <CustomNavbar  type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container mt-3 mb-3">
          {
            loading ? (
              <div className="d-flex justify-content-center">
                <Spinner 
                  animation="border" 
                  role="status" 
                  className="d-flex justify-content-center" />
              </div>
            ) : (
              <>
                <UserHeadDetail data={data} type={props.match.params.type} />
                <div className="my-4">
                  <UserHeadDetailMenu id={props.match.params.id} type={props.match.params.type} />
                    <div className="mt-4 mb-3">
                    <div className="d-flex aling-items-center justify-content-between px-2">
                      <h5 className="font-weight-bold text-uppercase">SALUD</h5>
                      <div>
                        <span className="text-muted mr-3"><i className="material-icons">water_drop</i> Tipo Sangre: {data.tipo_sangre ? data.tipo_sangre : 'No registrado aún'}</span>
                        <span className="text-muted mr-3"><i className="material-icons">cake</i> Fecha Nacimiento: {moment(data.fecha_cumpleaños).format('DD/MM/YYYY')}</span>
                        <span className="text-muted"><i className="material-icons">access_time</i> Edad:  {(moment().diff(moment(data.fecha_cumpleaños), 'years'))} 
                      {/* { parseInt(data.edad)}  */}
                      &nbsp;años</span>
                      </div>
                    </div>
                    <hr className="mb-3" />
                    <div className="mt-4 mb-4">
                      {
                        data.Salud_List ? (
                          <Table variant="dark">
                            <thead>
                              <tr>
                                <th scope="col">Diagnóstico</th>
                                <th scope="col">Enfermedad</th>
                                <th scope="col">Fecha</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                data.Salud_List.map(item => (
                                  <tr key={item.id}>
                                    <td>{item.diagnostico_list[0].descripcion}</td>
                                    <td>{item.enfermedad}</td>
                                    <td>{new Date(item.fecha).toLocaleDateString()}</td>
                                  </tr>
                                ))
                              }
                            </tbody>
                          </Table>
                        ): (
                          <Alert variant="info">
                            <p>No registrados aún</p>
                          </Alert>
                        )
                      }
                    </div>
                    <div className="mb-3">
                      <h5 className="font-weight-bold text-uppercase">beneficiarios</h5>
                      <hr />
                      {
                        data.Beneficiario_Seguro_List ? (
                          <Table variant="dark">
                            <thead>
                              <tr>
                                <th scope="col">Identidad</th>
                                <th scope="col">Nombre Completo</th>
                                <th scope="col">Parentesco</th>
                                <th scope="col">Fecha de Nacimiento</th>
                                <th scope="col">Numero de telefono</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                data.Beneficiario_Seguro_List.map(item => (
                                  item.parentesco_list.map(parent => (
                                    <tr key={item.id}>
                                      <td>{item.identidad}</td>
                                      <td>{item.nombre}</td>
                                      <td>{parent.nombre}</td>
                                      <td>{item.fecha_nacimiento}</td>
                                      <td>{item.telefono}</td>
                                    </tr>
                                  ))
                                ))
                              }
                            </tbody>
                          </Table>
                        ): (
                          <Alert variant="info">
                            <p>No registrados aún</p>
                          </Alert>
                        )
                      }
                    </div>
                  </div>
                </div>
              </>
            )
          }
          {
            vaccinesLoading ? (
              <div className="d-flex justify-content-center">
                <Spinner 
                  animation="border" 
                  role="status" 
                  className="d-flex justify-content-center" />
              </div>
            ) : (
              <>
                <div className="mb-3">
                  <h5 className="font-weight-bold text-uppercase">vacunas</h5>
                  <hr />
                  {
                    vaccines.length > 0 ? (
                      <Table variant="dark">
                        <thead>
                          <tr>
                            <th scope="col">Nombre vacuna</th>
                            <th scope="col">Laboratorio/Casa</th>
                            <th scope="col">Fecha de la dósis</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            vaccines.map(item => (
                              <tr key={item.id}>
                                <td>{item.vacuna_list[0].nombre}</td>
                                <td>{item.vacuna_list[0].laboratorio_list[0].nombre}</td>
                                <td>{moment(item.fecha).format('DD/MM/YYYY')}</td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </Table>
                    ): (
                      <Alert variant="info">
                        <p>No registrados aún</p>
                      </Alert>
                    )
                  }
                </div>
              </>
            )
          }
        </div>
      </div>
      <Modal
        show={showModal}
        backdrop="static"
        keyboard={false}
        centered
        size="lg">
        <Modal.Body className="p-0">
          <Card className="border-0">
            <Card.Body className="p-0">
              <Alert variant="danger" className="m-0 p-5" dismissable>
                <Row className="align-items-center">
                  <Col md="auto">
                    <img style={{width: '240px'}} src={accesoDenegado} alt="Acceso denegado" />
                  </Col>
                  <Col>
                    <Alert.Heading className="text-uppercase font-weight-bold">Acceso denegado</Alert.Heading>
                    <p className="my-3">
                      Usted no tiene autorización para ver la ficha de salud del empleado, contacte al departamento recursos humanos para solicitar acceso
                    </p>
                    <Button variant="danger" onClick={() => props.history.goBack()}>Regresar</Button>
                  </Col>
                </Row>
              </Alert>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default withRouter(Health)